<template>
  <div
    class="
      cbg-white-container
      input-container
      theme--light
      v-card
      p-16
      border-card
    "
  >
    <v-row>
      <v-col cols="12" md="6" class="border-right">
        <div class="table-div overflow-auto">
          <table class="table">
            <thead>
              <tr class="table-success">
                <th>Role</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Pharmacy</td>
                <td>&#8377; 200</td>
              </tr>
              <tr>
                <td>Doctor</td>
                <td>&#8377; 200</td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <v-col cols="12">
          <label for="">Amount</label>
          <input type="text" class="form-control" placeholder="00" />
        </v-col>
        <v-col cols="12">
          <div class="position-relative">
            <label for>Vertical </label>
            <select name id class="form-control">
              <option value="Pharmacy">Pharmacy</option>
              <option value="Doctor">Doctor</option>
            </select>
            <span class="drop-icon">
              <i
                aria-hidden="true"
                class="v-icon mdi mdi-menu-down theme--light position-absolute"
              ></i>
            </span>
          </div>
        </v-col>
        <v-col cols="12" class="text-right">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="openSwal(item, true)">Save</v-btn>
        </v-col>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  methods: {
    openSwal(item, valid) {
      Swal.fire({
        text: "Are you sure you want to save the amount for the vertical name?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {});
    },
  },
};
</script>